import React, { useState, useEffect, useRef } from 'react';
import Icon from 'icon';

import s from './dropdown.module.scss';

export default function DropDown({
  children,
  className,
  title,
  sideEffect,
  callback,
  Title,
  ...props
}) {
  // State
  const [active, setActive] = useState(false);
  const content = useRef(null);
  const heightTimeout = useRef();
  const [height, setHeight] = useState(null);

  // Functions
  function updateHeight(count = 0) {
    // upadtes height
    const newHeight = content.current.getBoundingClientRect().height;
    if (!newHeight && count <= 5) {
      heightTimeout.current = setTimeout(() => {
        if (count === 5) {
          const newerHeight = content.current.getBoundingClientRect().height;
          setHeight(prevHeight => newerHeight || prevHeight);
        } else {
          updateHeight(count + 1);
        }
      }, 500);
    } else {
      setHeight(newHeight);
    }
  }

  const handleActive = newActive => {
    updateHeight();
    setActive(newActive);
    if (callback) {
      callback();
    }
  };

  // Effects
  useEffect(() => {
    // sets up listener for resizing window because the height of the content might change.
    window.addEventListener('resize', updateHeight);
    return () => {
      clearTimeout(heightTimeout.current);
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  useEffect(() => {
    handleActive(!sideEffect);
  }, [sideEffect]);

  return (
    <div className={`${s.root} ${className || ''}`}>
      <div className={s.titleWrapper}>{children[0]}</div>
      <div className={s.content} style={{ height: active ? height : '0' }}>
        <div className={s.child} ref={content}>
          {children[1]}
        </div>
      </div>
    </div>
  );
}
